import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React, { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";

const DashboardDetailedView = () => {
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();

    // const initialEntries = Number(searchParams.get("entries")) || 10;
    // const initialPage = Number(searchParams.get("page")) || 1;

    const [pageIndex, setPageIndex] = useState(0);
    const [entries, setEntries] = useState(10);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch: useFetchDailyPlan } = useAPIQuery({
        key: "daily-plan",
        endpoint: "/api/daily-plan/",
    });
    const { data, isLoading, isFetching, isError } = useFetchDailyPlan({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            action: "job_card",
            wo_id: location.state?.id,
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const columns = [
        {
            accessor: "daily_plan_code",
            header: "Daily Plan",
        },
        {
            accessor: "machine",
            header: "Machine",
            cell: (row) => <>{row?.machine?.machine_name ?? "-"}</>,
        },
        {
            accessor: "item",
            header: "Item",
            cell: (row) => <>{row?.item?.item_name}</>,
        },
        {
            accessor: "date",
            header: "Date",
        },
        {
            accessor: "percentage",
            header: "Progress",
            cell: (row) => <>{`${row?.percentage?.toFixed(2)}%`}</>,
        },
    ];

    const handlePagination = (value) => {
        // setSearchParams({
        //     entries: value.pageSize,
        //     page: value.pageIndex + 1,
        // });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };
    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    if (!location.state?.id || isError) return <Error />;
    if (isLoading) return "Loading...";
    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            Job Card Details - {location.state?.work_order_code}
                        </h4>
                    </div>
                </div>
            </div>
            <Table
                data={data ? data?.results?.data : []}
                columns={columns}
                isLoading={isLoading || isFetching}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data?.count : 0}
                selectRows={false}
                filterModal={false}
                editRows={false}
                deleteRows={false}
                onPaginationChange={handlePagination}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
            />
        </>
    );
};

export default DashboardDetailedView;
